import { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { getApiToken } from '../authUtils';
import { backend_api_base_url } from '../config/urlconfig';

/** Authenticated JSON requests for the access-control screens. Errors carry the HTTP status. */
export const useApi = () => {
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  return useCallback(async (path, method = 'GET', body) => {
    const token = await getApiToken(instance, account);
    const res = await fetch(`${backend_api_base_url}${path}`, {
      method,
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) {
      const err = new Error(`API ${res.status}`);
      err.status = res.status;
      throw err;
    }
    return res.json();
  }, [instance, account]);
};
